import React from "react"
import { Link as GatsbyLink } from "gatsby"

export default function Link ({ to, state, children, ...props }) {

	// const linkTitle = title || (typeof children === 'string') && children

	if (!to) {
		return <a {...props}>{children}</a>
	} else {
		const isExternal = to.indexOf('http') === 0 || to.indexOf('mailto:') === 0 || to.indexOf('tel:') === 0
		const externalProps = isExternal ? { target: "_blank", rel: "noopener noreferrer", ...props } : props

		if (isExternal) {
			return <a href={to} {...externalProps}>{children}</a>
		} else {
			return <GatsbyLink to={to} state={state} {...props}>{children}</GatsbyLink>
		}
	}
}
